export default function buildXmlTag(tag, value) {
  const content = typeof value === 'string' ? value : JSON.stringify(value);
  return `<${tag}>${content}</${tag}>`;
}
